// src/hooks/UseAuth.js
import { useSelector } from 'react-redux';

const UseAuth = () => {
    // Direct state access since we're using single reducer
    const userRoles = useSelector(state => state.userRoles);
    const isLoading = useSelector(state => state.isLoading);
    
    return { userRoles, isLoading };
};

export default UseAuth;